import React, { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import BuyNFTContainer from "../../commons/NFT/BuyNFTContainer";

export default function CreatorOnSaleNFTList(props) {

  const { walletAddress } = props

  const [isLoading, setIsLoading] = useState(false)
  const { Moralis, isInitialized } = useMoralis()
  const [yourOnSaleNftList, setYourOnSaleNftList] = useState([])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (isInitialized) {
      try {
        setIsLoading(true)
        const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
        const query = new Moralis.Query(CreatedMarketplaceItems)
        query.equalTo('sold', false)
        query.equalTo('seller', walletAddress.toLowerCase())
        query.notEqualTo('userSellingPause', true)
        const result = await query.find()
        setYourOnSaleNftList(result)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAddress, isInitialized])

  return (
    <div className='row'>

      {
        isLoading ? (
          <div className='col-lg-12'>
            <div className='loading-container'>
              <div className="spinner-grow" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (

          yourOnSaleNftList && yourOnSaleNftList.length > 0 ?
            (
              <div className='row'>
                {
                  yourOnSaleNftList.map((item, index) => (
                    <div key={index} className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <BuyNFTContainer data={item.attributes} objectId={item.id} />
                    </div>

                  ))
                }
              </div>
            ) : (
              <div className='row'>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='loading-container'>
                    Sorry no items available for sale
                  </div>
                </div>
              </div>
            )
        )
      }

    </div>
  );
}


